import Vue from 'vue';

const state = {};

const getters = {};

const mutations = {};

const actions = {
  validateEmail(_, email) {
    return new Promise((resolve, reject) => {
      try {
        Vue.http.get(`${wwfconfigs.WEB_API}/kickbox/validate/email?email=${email}`).then(async response => {
          resolve(response.body);
        }, error => {
          reject(error);
        });
      } catch (err) {
        reject(err);
      }
    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/kickbox.js